import { useCallback, useEffect, useState } from "react";

const makeEmpty = () => ({
  id: null,
  name: "",
  active: true,
  image_name: null,
  imageFile: null,
  preview: null,
});

export function useSubStationInputs(initial = [makeEmpty()]) {
  const [subStationInputs, setSubStationInputs] = useState(initial);
  const [isMulti, setIsMulti] = useState(false);

  const minSubStationInputs = isMulti ? 2 : 1;

  useEffect(() => {
    setSubStationInputs((prev) => {
      if (prev.length >= minSubStationInputs) return prev;
      return [
        ...prev,
        ...Array(minSubStationInputs - prev.length)
          .fill(null)
          .map(makeEmpty),
      ];
    });
  }, [minSubStationInputs]);

  const onChangeSubStationName = useCallback((index, value) => {
    setSubStationInputs((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], name: value };
      return next;
    });
  }, []);

  const onChangeSubStationActive = useCallback((index, value) => {
    setSubStationInputs((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], active: value };
      return next;
    });
  }, []);

  const onSelectSubStationImage = useCallback((index, e) => {
    const file = e.files?.[0];
    setSubStationInputs((prev) => {
      const next = [...prev];
      next[index] = {
        ...next[index],
        imageFile: file || null,
        preview: file ? file.objectURL || URL.createObjectURL(file) : null,
      };
      return next;
    });
  }, []);

  const onAddSubStationInput = useCallback(() => {
    setSubStationInputs((prev) => [...prev, makeEmpty()]);
  }, []);

  const onRemoveSubStationInput = useCallback(
    (index) => {
      setSubStationInputs((prev) => {
        if (prev.length <= minSubStationInputs) return prev;
        return prev.filter((_, i) => i !== index);
      });
    },
    [minSubStationInputs],
  );

  return {
    subStationInputs,
    setSubStationInputs,
    isMulti,
    setIsMulti,
    minSubStationInputs,
    onChangeSubStationName,
    onChangeSubStationActive,
    onSelectSubStationImage,
    onAddSubStationInput,
    onRemoveSubStationInput,
  };
}

export const makeEmptySubStation = makeEmpty;
